import { UnlayerOptions } from "react-email-editor";
import * as env from "shared/env";
import { getUploadSignature } from "api/api";

const mergeTags = [
	{
		name: "Lead First Name",
		value: "{{first_name}}",
	},
	{
		name: "Lead Last Name",
		value: "{{last_name}}",
	},
	{
		name: "Your Name",
		value: "{{client_name}}",
	},
	{
		name: "Phone",
		value: "{{phone_number}}",
	},
	{
		name: "Website",
		value: "{{web_site}}",
	},
]

export function hasPendingImages(design: object): boolean {
	return JSON.stringify(design).includes('"pending":true');
}

export const unlayerOptions: UnlayerOptions = {
	id: "editor",
	version: "latest",
	projectId: 650,
	displayMode: "email",
	mergeTags,
	features: {
		// @ts-ignore - `ai` is not in the bundled @types/react-email-editor (v1.1); disables all Unlayer AI features
		ai: false,
	},
	customCSS: [
		`
		table {
			max-width: 500px;
		}
		body {
			max-width: 500px;
		}
		`,
	],
	tools: {
		"custom#dynamic_content": {
			position: 4,
			properties: {
				// @ts-ignore — react-email-editor's ToolPropertiesConfig typing narrowed across the
				// npm-10 lockfile regeneration (caret drift); runtime shape is unchanged and valid.
				ContentType: {
					editor: {
						data: {
							options: [
								{
									label: "Similar Listings",
									value: "{{similar_listings}}",
								},
								{
									label: "Area Stats",
									value: "{{area_stats}}",
								},
							],
						},
					},
				},
			},
		},
		button: {
			position: 3,
		},
		video: {
			position: 5,
		},
		text: {
			position: 1,
		},
		image: {
			position: 2,
		},
		divider: {
			position: 6,
		},
	},
	// @ts-ignore
	imageUpload: (file, done) => {
		const uploadPreset = env.cloudinaryUploadPreset || "";
		getUploadSignature(uploadPreset).then((signedParams: any) => {
			const formData = new FormData();
			formData.append("file", file);
			formData.append("upload_preset", uploadPreset);
			formData.append("api_key", signedParams.apiKey);
			formData.append("timestamp", signedParams.uploadSignatureTimestamp);
			formData.append("signature", signedParams.uploadSignature);
			formData.append("source", "uw");
			fetch(`https://api.cloudinary.com/v1_1/${env.cloudinaryCloudName}/image/upload`, {
				method: "POST",
				body: formData,
			})
			.then(r => r.json())
			.then(data => done({ progress: 100, url: data.secure_url }));
		});
	},
};